<template>
    <v-layout fill-height>
      <v-flex>
        <v-flex class="gray--text">{{ title }}</v-flex>
        <v-flex class="subheading" ><span v-html="text"></span></v-flex>
      </v-flex>
    </v-layout>
</template>

<script>
export default {
  name: 'LabelText',
  props: ['title', 'text'
  ]
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LabelText.vue